
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function AtelierMeVEREcosystem() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const products = [
    {
      title: 'MeVER Chair',
      desc: '人間工学に基づいたワークチェア。Atelier Folioと組み合わせて、最高のクリエイティブ環境を。',
      icon: 'ri-armchair-line',
      link: '/chair',
      image:
        'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/726c9d9456ce6d5e005d1641c838ee88.png?format=webp&quality=80',
    },
    {
      title: 'コワーキング体験',
      desc: '新宿のコワーキングスペースでMeVER製品を実際に体験。Atelier Folioも試せます。',
      icon: 'ri-building-2-line',
      link: '/coworking',
      image:
        'https://public.readdy.ai/ai/img_res/6eaed61ebdf274e6502624cd54dfa425.jpg',
    },
    {
      title: 'TEA サブスク',
      desc: 'クリエイティブワークのお供に。厳選された日本茶で、集中力とリラックスを。',
      icon: 'ri-cup-line',
      link: '/tea',
      image:
        'https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20of%20Japanese%20green%20tea%20ceremony%20items%20on%20dark%20wooden%20table%20with%20matcha%20powder%20bamboo%20whisk%20ceramic%20cups%20dried%20tea%20leaves%20scattered%20artistically%20warm%20moody%20lighting%20cinematic%20food%20photography%20earth%20tones%20dark%20aesthetic&width=400&height=300&seq=tea-eco-001&orientation=landscape',
    },
  ];

  return (
    <section
      ref={ref}
      className="py-20 sm:py-28 bg-[#0F0F0F] relative"
      aria-labelledby="af-ecosystem-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div
          className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-5">
            <i
              className="ri-links-line text-[#8E7AB5] text-sm"
              aria-hidden="true"
            ></i>
            <span className="text-xs text-white/50 font-light tracking-wider">
              MeVER ECOSYSTEM
            </span>
          </span>
          <h2
            id="af-ecosystem-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight"
          >
            MeVERの世界と、つながる
          </h2>
          <p className="text-sm sm:text-base text-white/40 font-light max-w-xl mx-auto">
            Atelier Folioは、MeVERのクリエイティブエコシステムの一部です
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 sm:gap-6">
          {products.map((p, i) => (
            <Link
              key={p.title}
              to={p.link}
              className={`group block rounded-xl overflow-hidden bg-white/5 border border-white/6 hover:border-[#8E7AB5]/30 transition-all duration-500 cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 150 + 200}ms` }}
            >
              <div className="relative w-full h-44 sm:h-48 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                  width={400}
                  height={300}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-[#0F0F0F]/40 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#8E7AB5]/20 backdrop-blur-md rounded-lg border border-[#8E7AB5]/30">
                    <i className={`${p.icon} text-[#8E7AB5] text-lg`} aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div className="p-5 sm:p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-white font-medium text-base">{p.title}</h3>
                  <i
                    className="ri-arrow-right-line text-white/30 group-hover:text-[#8E7AB5] group-hover:translate-x-1 transition-all text-sm"
                    aria-hidden="true"
                  ></i>
                </div>
                <p className="text-white/35 text-xs sm:text-sm font-light leading-relaxed">
                  {p.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
